import get from 'lodash/get';
import type { QnAStateType } from '../index';
export const getModalState = (state: QnAStateType, type: string) => get(state, `modals.${type}`) || {};